import {SpeedBumpStateType, SpeedBumpType} from './state'
import {speedBumpAC} from './speedBump.duck'

export const applyGenericConfirmSpeedBumpDefaults: any = () => (dispatch) => {
  const genericConfirmSpeedBumpState = {
    type: SpeedBumpType.genericConfirm,
    variant: 'information',
    title: 'Confirm',
    body: 'Are you sure you want to proceed?',
  } as SpeedBumpStateType

  dispatch(speedBumpAC.speedBumpStateApplied(genericConfirmSpeedBumpState))
}

export const applyGenericSuccessSpeedBumpDefaults: any = () => (dispatch) => {
  const genericConfirmSpeedBumpState = {
    type: SpeedBumpType.genericSuccess,
    variant: 'success',
    title: 'Success',
    body: 'Success, please proceed.',
  } as SpeedBumpStateType

  dispatch(speedBumpAC.speedBumpStateApplied(genericConfirmSpeedBumpState))
}

export const applyRescheduleFailedJobsSpeedBumpDefaults: any = () => (dispatch) => {
  const genericConfirmSpeedBumpState = {
    type: SpeedBumpType.rescheduleFailedJobs,
    variant: 'caution',
    title: 'Reschedule Jobs',
    body: 'This will reschedule selected jobs. Proceed?',
  } as SpeedBumpStateType

  dispatch(speedBumpAC.speedBumpStateApplied(genericConfirmSpeedBumpState))
}

export const applyBulkEditForAllUrlsSpeedBumpDefaults: any = () => (dispatch) => {
  const genericConfirmSpeedBumpState = {
    type: SpeedBumpType.bulkEditForAllUrls,
    variant: 'caution',
    title: 'Bulk Edit',
    body: 'Are you sure you want the configuration to be updated for "All" urls?',
  } as SpeedBumpStateType

  dispatch(speedBumpAC.speedBumpStateApplied(genericConfirmSpeedBumpState))
}
